import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyAttrezzatureService
 * Client API per attrezzature/impianti soggetti a verifica periodica e
 * relativo storico verifiche (modulo "Gestione Adempimenti Sicurezza").
 */
export default class SafetyAttrezzatureService {
    /** Catalogo tipi (opz. categoria = "ATTREZZATURA" | "IMPIANTO" | "ANTINCENDIO", settore). */
    static getTipi = (categoria = "", settore = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/tipi`;
            const payload = {};
            if (categoria) payload.categoria = categoria;
            if (settore) payload.settore = settore;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    /** Attrezzature di un'azienda. */
    static byAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/byAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    /** Crea un'attrezzatura (FormData con eventuale libretto). */
    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/create`;
        return ApiService.postFormData(url, formData);
    };

    /** Elimina (soft) un'attrezzatura. */
    static deleteAttrezzatura = (id_attrezzatura) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/delete`;
            ApiService.postRequest(resolve, reject, url, { id_attrezzatura });
        });
    };

    /** Scarica il libretto/manuale dell'attrezzatura. */
    static download = (id_attrezzatura, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_attrezzatura, filename });
        });
    };

    /** Storico verifiche di un'attrezzatura. */
    static verifiche = (id_attrezzatura) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/verifiche`;
            ApiService.postRequest(resolve, reject, url, { id_attrezzatura });
        });
    };

    /** Registra una verifica (FormData con eventuale verbale). */
    static createVerifica = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/verifica/create`;
        return ApiService.postFormData(url, formData);
    };

    /** Elimina (soft) una verifica. */
    static deleteVerifica = (id_verifica) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/verifica/delete`;
            ApiService.postRequest(resolve, reject, url, { id_verifica });
        });
    };

    /** Scarica il verbale di una verifica. */
    static downloadVerifica = (id_verifica, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attrezzature/verifica/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_verifica, filename });
        });
    };
}
